import * as countries from 'i18n-iso-countries'
import { T, always, cond, pipe, sort, mapObjIndexed } from 'ramda'
import { isArabic, isFrench, isHebrew, isPersian } from '../../utilities/locales'

// These utilities have not been merged in the utils module to avoid to download
// them when not necessary. This way the browser it will download them just
// when navigating to the profile pages.

// loadCountriesArabic :: Countries -> Countries
const loadCountriesArabic = countries => pipe(
  () => countries.registerLocale(require(`i18n-iso-countries/langs/ar.json`)),
  always(countries),
)

// loadCountriesEnglish :: Countries -> Countries
const loadCountriesEnglish = countries => pipe(
  () => countries.registerLocale(require(`i18n-iso-countries/langs/en.json`)),
  always(countries),
)

// loadCountriesFrench :: Countries -> Countries
const loadCountriesFrench = countries => pipe(
  () => countries.registerLocale(require(`i18n-iso-countries/langs/fr.json`)),
  always(countries),
)

// loadCountriesHebrew :: Countries -> Countries
const loadCountriesHebrew = countries => pipe(
  () => countries.registerLocale(require(`i18n-iso-countries/langs/he.json`)),
  always(countries),
)

// loadCountriesPersian :: Countries -> Countries
const loadCountriesPersian = countries => pipe(
  () => countries.registerLocale(require(`i18n-iso-countries/langs/fa.json`)),
  always(countries),
)

// getCountriesByLocale :: String -> Countries
// We need to load countries this way to optimize Webpack tree shaking. Using
// a variable to construct the `require` path would cause all the translations
// to be included in the production bundle
export const getCountriesByLocale = pipe(
  cond([
    [isArabic, loadCountriesArabic(countries)],
    [isFrench, loadCountriesFrench(countries)],
    [isHebrew, loadCountriesHebrew(countries)],
    [isPersian, loadCountriesPersian(countries)],
    [T, loadCountriesEnglish(countries)],
  ]),
)

// getAlphabeticallySortedCountriesByLocale :: String -> Array
export const getAlphabeticallySortedCountriesByLocale = locale => pipe(
  getCountriesByLocale,
  countries => countries.getNames(locale, { select: 'alias' }),
  mapObjIndexed((countryName, countryCode) => ({ code: countryCode, name: countryName })),
  Object.values,
  sort((a, b) => a.name.localeCompare(b.name)),
)(locale)
